export default "__VITE_ASSET__aaa8860a__"